import { combineReducers } from 'redux';

import { stockConstants } from '../constants';

const lookupRelated = (
  state = {
    loading: false,
    categoryStats: undefined,
    subCategoryStats: undefined,
    realtime: undefined,
  },
  action
) => {
  switch (action.type) {
    case stockConstants.LOOKUP_CATE_REQUEST: {
      return {
        loading: true,
      };
    }
    case stockConstants.LOOKUP_CATE_SUCCESS: {
      return {
        categoryStats: action.categoryStats,
        subCategoryStats: action.subCategoryStats,
        realtime: action.realtime,
      };
    }
    case stockConstants.LOOKUP_CATE_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  lookupRelated,
});
